var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reports-new__info"},[_c('app-tabs',{staticClass:"reports-new__info-tabs",attrs:{"mode":"s","value":_vm.tab,"items":_vm.tabs},on:{"update:value":function($event){_vm.tab=$event}}}),_c(_vm.component,{tag:"component",staticClass:"reports-new__info-tab",attrs:{"data":_vm.data,"club-id":_vm.clubId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }